// Human-readable published date, localized. Falls back to the raw string if the
// date can't be parsed.

const LOCALE = { en: "en-GB", id: "id-ID" };

export const formatDate = (value, language) => {
  if (!value) return "";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return value;
  return date.toLocaleDateString(LOCALE[language] || "en-GB", {
    day: "numeric",
    month: "long",
    year: "numeric",
  });
};
